import { render } from "./DevicePage.vue?vue&type=template&id=bb8e5f60&scoped=true"
import script from "./DevicePage.vue?vue&type=script&lang=js"
export * from "./DevicePage.vue?vue&type=script&lang=js"

import "./DevicePage.vue?vue&type=style&index=0&id=bb8e5f60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8e5f60"]])

export default __exports__